import axios from 'axios'

export const API_URL = `https://security.ncore.kg/api/`
let formData = new FormData()
const $api = axios.create({
  withCredentials: true,
  baseURL: API_URL,

  headers: {
    Accept: 'application/json',
    'Content-Type': `multipart/form-data;application/json; boundary=${formData._boundary}`,
  },
})

$api.interceptors.request.use((config) => {
  const t = localStorage.getItem('token')
  if (t) {
    config.headers.Authorization = `Bearer ${t}`
  } else {
    // ensure header not sent as 'Bearer null' or similar
    delete config.headers.Authorization
  }
  return config
})

// $api.interceptors.response.use(
//   (config) => {
//     return config;
//   },
//   async (error) => {
//     const originalRequest = error.config;
//     if (
//       error.response.status === 401 &&
//       error.config &&
//       !error.config._isRetry
//     ) {
//       originalRequest._isRetry = true;
//       try {
//         const response = await axios.get(`${API_URL}/refresh`, {
//           withCredentials: true,
//         });
//         localStorage.setItem("token", response.data.accessToken);
//         return $api.request(originalRequest);
//       } catch (e) {
//         console.log("НЕ АВТОРИЗОВАН");
//       }
//     }
//     throw error;
//   }
// );

export default $api

// publicApi: same base URL but without Authorization header and default JSON content-type
export const publicApi = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});
